<template>
  <div class="edit-product-price-dailog container-block col-block">
    <div class="title-container row-block default-shadow">
      <div class="row-block" :style="{ width: '35px' }"></div>
      <div
        class="title"
        v-html="param.title"
      ></div>
      <div class="row-block close-button" :style="{ width: '35px' }">
        <!-- <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')"> -->
      </div>
    </div>
    <div class="product-price-container col-block" :style="{ flex: 1 }">
      <customRowForm
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field1']"
        @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
      ></customRowForm>
      <customRowForm
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field2']"
        @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
      ></customRowForm>
      <div class="packing-container" :class="[['bulk'].includes(result.packing_method) ? 'red' : ['packed', 'cut'].includes(result.packing_method) ? 'blue' : '']">
        <customRowForm
          :init="productPrice"
          :alerts="alerts"
          :disabled="!editable"
          :forms="formOptions['field3']"
          @change="(result, validate, errors) => formOnChange('field3', result, validate, errors)"
        ></customRowForm>
      </div>
      <customRowForm
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field4']"
        @change="(result, validate, errors) => formOnChange('field4', result, validate, errors)"
      ></customRowForm>
      <customRowForm
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field5']"
        @change="(result, validate, errors) => formOnChange('field5', result, validate, errors)"
      ></customRowForm>
      <customRowForm
        v-if="!param.image"
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field6']"
        @change="() => {}"
      >
        <template slot="_FILES" slot-scope="props">
          <div :name="props" class="_FILES">
            <div class="file-container row-block stretch">
              <template v-if="editable">
                <div class="mask" :class="{ disabled: allFiles.length >= 2 }">
                  <label for="upload"></label>
                  <input v-show="false" type="file" id="upload" accept="image/gif,image/png,image/jpg,image/jpeg,image/webp" multiple :disabled="allFiles.length >= 2" @change="e => fileTypeCheck(e, e => fileUpload(e), () => addToast('error', '圖檔'))">
                  <button class="main-button">
                    <span>選擇檔案</span>
                  </button>
                </div>
                <div :style="{ width: '20px' }"></div>
              </template>
              <div class="file-list row-block" :style="{ flex: 1, width: 0 }">
                <div class="file-block row-block" v-for="(file, index) in allFiles" :key="index">
                  <a class="file-text row-block" :href="file.url" target="_blank">
                    <div class="file-title" :title="file.name">{{ file.name }}</div>
                    <div :style="{ width: '3px' }"></div>
                    <div class="file-size">{{ '(' + convertFileSize(file.size) + ')' }}</div>
                  </a>
                  <template v-if="editable">
                    <div :style="{ width: '15px' }"></div>
                    <img :src="require('../../assets/images/remove-file-icon.svg')" alt="" @click="e => removeFile(file)">
                  </template>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="file-alert" v-if="alerts['_FILES'] && alerts['_FILES'].type === 'error'">{{ alerts['_FILES'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <customRowForm
        :init="productPrice"
        :alerts="alerts"
        :disabled="!editable"
        :forms="formOptions['field7']"
        @change="(result, validate, errors) => formOnChange('field6', result, validate, errors)"
      >
        <template slot="_FILES" slot-scope="props">
          <div :name="props" class="_FILES">
            <div class="file-container img col-block">
              <div class="img-list row-block" :style="{ flex: 1 }">
                <div class="img-block col-block stretch" v-for="(file, index) in allFiles" :key="index">
                  <div class="img-content center-block">
                    <img :src="file.url" alt="">
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="img-options row-block">
                    <a class="open" :href="file.url" target="_blank">在新分頁開啟照片</a>
                    <div v-if="editable" class="remove" @click="e => removeFile(file)">移除</div>
                    <div v-else></div>
                  </div>
                </div>
              </div>
              <template v-if="editable">
                <div class="mask" :class="{ disabled: allFiles.length >= 2 }">
                  <label for="upload"></label>
                  <input v-show="false" type="file" id="upload" accept="image/gif,image/png,image/jpg,image/jpeg,image/webp" multiple :disabled="allFiles.length >= 2" @change="e => fileUpload(e)">
                  <button class="main-button">
                    <span>選擇檔案</span>
                  </button>
                </div>
              </template>
              <div class="file-alert" v-if="alerts['_FILES'] && alerts['_FILES'].type === 'error'">{{ alerts['_FILES'].msg }}</div>
            </div>
          </div>
        </template>
      </customRowForm>
      <div :style="{ height: '10px' }"></div>
      <div class="button-container row-block">
        <div :style="{ flex: 1 }"></div>
        <template v-if="review">
          <button type="button" name="button" class="alert-button" :class="{ loading: onReview }" @click="e => reviewProductPrice('fail')">
            <span>不通過</span>
          </button>
          <div :style="{ flexBasis: '20px' }"></div>
        </template>
        <button type="button" name="button" class="gray-button" @click="e => $emit('changeModal')">
          <span>{{ editable ? '取消' : '返回' }}</span>
        </button>
        <template v-if="review">
          <div :style="{ flexBasis: '20px' }"></div>
          <button type="button" name="button" class="main-button" :class="{ loading: onReview }" @click="e => reviewProductPrice('pass')">
            <span>通過</span>
          </button>
        </template>
        <template v-if="editable && !review">
          <div :style="{ flexBasis: '20px' }"></div>
          <button type="button" name="button" class="main-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validateEditProductPrice()">
            <span>{{ this.param.data ? '更新' : '送出'}}</span>
          </button>
        </template>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCurrencys, getCrops, getProductPrice, getAdminProductPrice, postProductPrice, putAdminProductPrice, postAdminProductPriceReview } from '../../api'
import customRowForm from '../../components/tool/customRowForm'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { convertFileSize, fileTypeCheck, imageReader } from '../../constants/global/util'

export default {
  components: {
    customRowForm
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      productPrice: {
        date: '',
        kind: '',
        crop_name: '',
        user_name: '',
        country: '',
        product_name: '',
        packing_method: '',
        price: '',
        quantity: '',
        quantity_unit_category: '',
        quantity_unit: '',
        currency: '',
        currency_other: '',
        exchange_rate: '',
        market_kind: '',
        market_name: '',
        market_country: '',
        notes: '',
        // custom
        _FILES: ''
      },
      defaultData: {},
      // options
      cropDatas: [],
      currencyOthers: [],
      // files
      files: [],
      addFiles: [],
      removeFileIDs: [],
      // form
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false,
      onReview: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'countrys'
    ]),
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    allFiles () {
      return this.files.concat(this.addFiles)
    },
    kindOptions () {
      return [
        { title: '蔬菜', value: 'vegetable' },
        { title: '水果', value: 'fruit' }
      ]
    },
    packingMethodOptions () {
      return [
        { title: '散裝', value: 'bulk', style: { color: '#EF6577' } },
        { title: '有包裝', value: 'packed', style: { color: '#3967A6' } },
        { title: '截切', value: 'cut', style: { color: '#3967A6' } }
      ]
    },
    quantityUnitCategoryOptions () {
      return [
        { title: '重量', value: 'weight' },
        { title: '數量', value: 'count' }
      ]
    },
    quantityUnitOptions () {
      return [
        { title: '公克', value: 'gram', type: 'weight' },
        { title: '公斤', value: 'kilogram', type: 'weight' },
        { title: '磅', value: 'pound', type: 'weight' },
        { title: '個', value: 'number', type: 'count' },
        { title: '包裝', value: 'package', type: 'count' }
      ]
    },
    marketKindOptions () {
      return [
        { title: '傳統市場', value: 'traditional_market' },
        { title: '批發市場', value: 'wholesale_market' },
        { title: '超市', value: 'supermarket' },
        { title: '量販店', value: 'hyper_market' },
        { title: '便利商店', value: 'convenience_store' },
        { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' },
        { title: '農夫(假日)市集', value: 'farmers_market' }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    currencyOptions () {
      return [
        { title: '歐元', value: '歐元' },
        { title: '美元', value: '美元' },
        { title: '英鎊', value: '英鎊' },
        { title: '日圓', value: '日圓' },
        { title: '泰銖', value: '泰銖' },
        { title: '馬幣', value: '馬幣' },
        { title: '越南盾', value: '越南盾' },
        { title: '澳元', value: '澳元' },
        { title: '其他', value: '其他' }
      ]
    },
    cropDataOptions () {
      return this.cropDatas || []
    },
    currencyOtherOptions () {
      return (this.currencyOthers || []).filter(currency => !this.currencyOptions.some(option => option.value === currency))
    },
    editable () {
      return !!this.param.editable
    },
    review () {
      return !!this.param.review
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: '拍攝日期',
            value: 'date',
            type: this.editable ? 'date' : 'text',
            width: '200px',
            placeholder: () => '2020/03/12',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '產品類別',
            value: 'kind',
            type: this.editable ? 'select' : 'text',
            width: '200px',
            options: this.kindOptions,
            placeholder: () => '蔬菜 / 水果',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '作物(產品)',
            value: 'crop_name',
            type: this.editable ? 'datalist' : 'text',
            lists: this.cropDataOptions.filter(option => option.kind === this.result.kind).map(option => option.name),
            onChange: value => {
              // if (value && !this.cropDatas.some(v => v === value)) {
              //   this.productPrice = {
              //     ...this.productPrice,
              //     ...this.result,
              //     crop_name: ''
              //   }
              // }
            },
            // width: '420px',
            placeholder: () => '請輸入農產品的作物名稱',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          }
        ],
        field2: [
          {
            title: '上傳者',
            value: 'user_name',
            type: this.editable ? 'text' : 'text',
            width: '200px',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '產地',
            value: 'country',
            type: this.editable ? 'datalist' : 'text',
            lists: [{ title: '無', country: { iso_name: '', chinese_name: '' } }, ...this.countryOptions].map(option => option.title),
            onChange: value => {
              if (value && value !== '無' && !this.countryOptions.some(option => option.title === value)) {
                this.productPrice = {
                  ...this.productPrice,
                  ...this.result,
                  country: ''
                }
              }
            },
            width: '200px',
            placeholder: () => '請選擇國家',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '品名',
            value: 'product_name',
            type: this.editable ? 'input' : 'text',
            // width: '420px',
            placeholder: () => '請輸入農產品上顯示的產品名稱',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          }
        ],
        field3: [
          {
            title: '包裝方式',
            value: 'packing_method',
            type: this.editable ? 'select' : 'text',
            width: '200px',
            options: this.packingMethodOptions,
            style: value => value ? {
              bulk: { color: '#EF6577' },
              packed: { color: '#3967A6' },
              cut: { color: '#3967A6' }
            }[value] : { color: '#777777' },
            placeholder: () => '散裝 / 有包裝 / 截切',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '價格',
            value: 'price',
            type: this.editable ? 'number' : 'text',
            width: '200px',
            placeholder: () => '請輸入數字',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: this.result.packing_method === 'bulk' ? '計價量' : '包裝量',
            value: 'quantity',
            type: this.editable ? 'number' : 'text',
            placeholder: () => '請輸入數字',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          ...this.editable ? [
            {
              title: this.result.packing_method === 'bulk' ? '計價單位' : '包裝單位',
              value: 'quantity_unit_category',
              type: this.editable ? 'select' : 'text',
              options: this.quantityUnitCategoryOptions,
              placeholder: () => '重量/數量',
              validate: this.editable ? 'required' : '',
              displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
            }
          ] : [],
          {
            title: this.editable ? '　' : this.result.packing_method === 'bulk' ? '計價單位' : '包裝單位',
            value: 'quantity_unit',
            type: this.editable ? 'select' : 'text',
            options: this.quantityUnitOptions.filter(option => !this.editable || option.type === this.result.quantity_unit_category),
            placeholder: () => ({
              weight: '公斤/公克...',
              count: '個/包裝...'
            }[this.result.quantity_unit_category]),
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          ...!this.editable ? [
            {
              title: '　',
              value: ''
            }
          ] : []
        ],
        field4: [
          ...this.editable ? [
            {
              title: '貨幣單位',
              value: 'currency',
              type: this.editable ? 'select' : 'text',
              options: this.currencyOptions,
              width: '200px',
              placeholder: () => '請選擇幣別 / 其他',
              validate: this.editable ? 'required' : '',
              displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
            }
          ] : [],
          {
            title: !this.editable ? '貨幣單位' : '　',
            value: 'currency_other',
            type: this.editable ? 'datalist' : 'text',
            lists: this.currencyOtherOptions,
            onChange: value => {
              if (value && !this.currencyOthers.some(v => v === value)) {
                // this.productPrice = {
                //   ...this.productPrice,
                //   ...this.result,
                //   currency_other: ''
                // }
              }
            },
            width: '200px',
            disabled: () => this.result.currency !== '其他',
            placeholder: () => '其他幣別',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          ...!this.editable ? [
            {
              title: '　',
              value: '',
              width: '200px'
            }
          ] : [],
          {
            title: '貨幣匯率 (與美元相比)',
            value: 'exchange_rate',
            type: this.editable ? 'input' : 'text',
            errorTitle: '貨幣匯率',
            width: '200px',
            placeholder: () => '',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '　',
            value: ''
          }
        ],
        field5: [
          {
            title: '市場類型',
            value: 'market_kind',
            type: this.editable ? 'select' : 'text',
            options: this.marketKindOptions,
            width: '200px',
            placeholder: () => '請選擇市場類型',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '市場名稱',
            value: 'market_name',
            type: this.editable ? 'input' : 'text',
            // width: '420px',
            placeholder: () => '請輸入市場名稱',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          },
          {
            title: '市場所在國家',
            value: 'market_country',
            type: this.editable ? 'datalist' : 'text',
            lists: this.countryOptions.map(option => option.title),
            onChange: value => {
              if (value && !this.countryOptions.some(option => option.title === value)) {
                this.productPrice = {
                  ...this.productPrice,
                  ...this.result,
                  market_country: ''
                }
              }
            },
            width: '200px',
            placeholder: () => '請選擇國家',
            validate: this.editable ? 'required' : '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          }
        ],
        field6: [
          {
            title: '產品照片(最多上傳兩張照片)',
            value: '_FILES',
            validate: this.editable ? 'required' : ''
          }
        ],
        field7: [
          {
            title: this.param.image ? '產品照片' : '產品照片(最多上傳兩張照片)',
            value: '_FILES',
            display: () => this.param.image,
            width: '420px',
            validate: this.editable ? 'required' : ''
          },
          {
            title: '備註說明',
            value: 'notes',
            type: this.editable ? 'textarea' : 'text',
            row: this.param.image ? 5 : 3,
            placeholder: () => '',
            displayText: (value, form) => this.editable ? value : (form.options ? (form.options.find(option => option.value === value) || {}).title : value) || '--'
          }
        ]
      }
    },
    // global
    convertFileSize () { return convertFileSize },
    fileTypeCheck () { return fileTypeCheck }
  },
  watch: {
    'result.quantity_unit_category' (nv, ov) {
      if (ov) {
        this.productPrice = {
          ...this.productPrice,
          ...this.result,
          quantity_unit: ''
        }
      }
      this.alerts = {
        ...this.alerts,
        quantity_unit: null
      }
    },
    'result.quantity_unit' () {
      this.alerts = {
        ...this.alerts,
        quantity_unit: null
      }
    },
    'result.currency' (nv, ov) {
      if (ov) {
        this.productPrice = {
          ...this.productPrice,
          ...this.result,
          currency_other: ''
        }
      }
      this.alerts = {
        ...this.alerts,
        currency_other: null
      }
    },
    'result.currency_other' (nv) {
      this.alerts = {
        ...this.alerts,
        currency_other: null
      }
      // nv && this.searchData('currencyOther', nv)
    },
    'result.crop_name' (nv) {
      // nv && this.searchData('cropName', nv)
    }
  },
  methods: {
    async fetchData () {
      await this.fetchCrops()
      await this.fetchCurrencys()
      await this.fetchProductPrice()
    },
    async fetchCrops () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getCrops('', config)
        let datas = response.data.data
        this.cropDatas = datas
      } catch (error) {
        throw error
      }
    },
    async fetchCurrencys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getCurrencys('', config)
        let datas = response.data.data
        datas = datas.map(data => data.name)
        this.currencyOthers = datas
      } catch (error) {
        throw error
      }
    },
    async fetchProductPrice () {
      if (this.param.data) {
        try {
          let config = this.$ls.get('userInfo')
          let id = this.param.data.id
          let api = this.param.admin ? getAdminProductPrice : getProductPrice
          let response = await api(id, config)
          let defaultData = response.data.data
          this.files = defaultData.photos.map(file => ({
            id: file.id,
            name: file.name,
            size: file.file_size,
            url: file.url
          }))
          defaultData = {
            ...defaultData,
            country: (this.countryOptions.find(option => option.value === defaultData.country) || {}).title || '無',
            quantity_unit_category: (this.quantityUnitOptions.find(option => option.value === defaultData.quantity_unit) || {}).type,
            currency: (this.currencyOptions.find(option => option.value === defaultData.currency_name) || {}).title || '其他',
            currency_other: this.currencyOptions.some(option => option.value === defaultData.currency_name) ? '' : defaultData.currency_name,
            market_country: (this.countryOptions.find(option => option.value === defaultData.market_country) || {}).title
          }
          if (!this.editable) {
            defaultData = {
              ...defaultData,
              currency_other: defaultData.currency === '其他' ? defaultData.currency_other : defaultData.currency
            }
          }
          this.defaultData = defaultData
        } catch (error) {
          throw error
        }
      } else {
        this.defaultData = {
          ...this.defaultData,
          packing_method: 'bulk'
        }
      }
    },
    async afterSetData () {
      this.productPrice = {
        ...this.productPrice,
        ...this.defaultData,
        user_name: this.productPrice.uploader || this.user.name
      }
    },
    // async searchData (type, query) {
    //   if (!this[type + 's'][query]) {
    //     try {
    //       let config = this.$ls.get('userInfo')
    //       let api = {
    //         cropName: getCrops,
    //         currencyOther: getCurrencys
    //       }[type]
    //       let response = await api(query, config)
    //       let datas = response.data.data
    //       datas = datas.filter(data => data.name.includes(query)).map(data => data.name)
    //       this[type + 's'] = {
    //         ...this[type + 's'],
    //         [query]: datas.length > 1 ? datas : []
    //       }
    //     } catch (error) {
    //       // this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
    //     }
    //   }
    // },
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
        quantity_unit: value => {
          if (this.result.quantity_unit_category && !value) {
            return {
              type: 'error',
              msg: '計價單位 為必填欄位'
            }
          }
        },
        currency_other: value => {
          if (this.result.currency === '其他' && !value) {
            return {
              type: 'error',
              msg: '貨幣單位 為必填欄位'
            }
          }
        },
        _FILES: value => {
          if (!this.allFiles.length) {
            return {
              type: 'error',
              msg: '產品照片 為必填欄位'
            }
          }
        }
      }
      for (let col of cols || Object.keys(this.productPrice)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async searchData (type, query) {
      if (!this[type + 's'][query]) {
        try {
          let config = this.$ls.get('userInfo')
          let api = {
            cropName: getCrops,
            currencyOther: getCurrencys
          }[type]
          let response = await api(query, config)
          let datas = response.data.data
          datas = datas.filter(data => data.name.includes(query)).map(data => data.name)
          this[type + 's'] = {
            ...this[type + 's'],
            [query]: datas.length > 1 ? datas : []
          }
        } catch (error) {
          // this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        }
      }
    },
    async fileUpload (e) {
      let files = Array.from(e.target.files)
      let limit = Math.max(2 - this.allFiles.length, 0)
      e.target.value = ''
      files = files.slice(0, limit)
      let urls = await imageReader(files, 'blobUrl')
      for (let i = 0; i < urls.length; i++) {
        files[i].url = urls[i]
      }
      this.addFiles = [
        ...this.addFiles,
        ...files
      ]
      this.alerts = {
        ...this.alerts,
        _FILES: null
      }
    },
    removeFile (file) {
      if (!file.lastModified) {
        this.removeFileIDs.push(file.id)
        this.files.splice(this.files.indexOf(file), 1)
      } else {
        this.addFiles.splice(this.addFiles.indexOf(file), 1)
      }
    },
    async validateEditProductPrice () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.editProductPrice()
      }
      this.onSubmit = false
    },
    async editProductPrice (isReview) {
      try {
        let config = this.$ls.get('userInfo')
        let id = (this.param.data || {}).id
        let data = {
          ...this.result,
          currency_name: this.result.currency === '其他' ? this.result.currency_other : this.result.currency,
          country: (this.countryOptions.find(option => option.title === this.result.country) || {}).value || '',
          market_country: (this.countryOptions.find(option => option.title === this.result.market_country) || {}).value,
          photos: this.addFiles
        }
        if (id) {
          data.remove_photo_ids = this.removeFileIDs
        }
        let response = id ? await putAdminProductPrice(id, data, config) : await postProductPrice(data, config)
        if (!isReview) {
          this.addToast('success', response.data.result || (id ? '更新成功' : '上傳成功'))
          this.$emit('changeModal', {}, true)
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async reviewProductPrice (result) {
      this.onReview = true
      await this.editProductPrice(true)
      try {
        let config = this.$ls.get('userInfo')
        let id = this.param.data.id
        let response = await postAdminProductPriceReview(id, result, config)
        this.addToast('success', response.data.result || '審核成功')
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
      this.onReview = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editProductPrice.vue